module.exports = __webpack_public_path__ + "static/media/powered-by-logo.4648471f.svg";